export default __webpack_public_path__ + "7df0b4bc22914ddf450dd861b8ba9904.png";